import { render, staticRenderFns } from "./LimitViz.vue?vue&type=template&id=0a31f282&scoped=true"
import script from "./LimitViz.vue?vue&type=script&lang=js"
export * from "./LimitViz.vue?vue&type=script&lang=js"
import style0 from "./LimitViz.vue?vue&type=style&index=0&id=0a31f282&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a31f282",
  null
  
)

export default component.exports